import type { Point2d } from "."
import { wrapAround } from "../utils"

const { PI } = Math

type Quadrant = `1st` | `2nd` | `3rd` | `4th`
export type RoundaboutWay = `antigraphwise` | `graphwise`
const QUADRANT_DEGREES: Record<Quadrant, number> = {
  "1st": 0,
  "2nd": PI,
  "3rd": PI,
  "4th": 2 * PI,
}

type FindQuadrant = (rise: number, run: number) => Quadrant
// prettier-ignore
export const findQuadrant: FindQuadrant = (rise, run) =>
  rise >= 0
    ? run >= 0
      ? `1st`
      : `2nd`
    : run < 0
      ? `3rd`
      : `4th`
// prettier-enable

type FindAngle = (p1: Point2d, p2: Point2d) => number

export const findSlope = (p1: Point2d, p2: Point2d): number => {
  const rise = p2.y - p1.y
  const run = p2.x - p1.x
  const slope = rise / run

  return slope
}

export const findAngle: FindAngle = (p1, p2) => {
  const rise = p2.y - p1.y
  const run = p2.x - p1.x
  const quadrant = findQuadrant(rise, run)
  const slope = rise / run
  const angle = Math.atan(slope) + QUADRANT_DEGREES[quadrant]

  return angle
}

type FindOffset = (
  from: number,
  to: number,
  direction?: RoundaboutWay,
  log?: boolean,
) => number

export const findOffset: FindOffset = (from, to, direction = `graphwise`) => {
  const between = to - from
  const oriented = direction === `graphwise` ? between : between * -1
  const wrapped = wrapAround(oriented, [0, 2 * PI])

  return wrapped
}

type FindOffsetAngle = (
  p1: Point2d,
  p2: Point2d,
  baseAngle: number,
  direction?: RoundaboutWay,
) => number

export const findOffsetAngle: FindOffsetAngle = (
  p1,
  p2,
  baseAngle,
  direction,
) => {
  const angle = findAngle(p1, p2)

  return findOffset(baseAngle, angle, direction)
}
